import { createContext } from 'react';

export interface Patient {
  patientId: number;
  email?: string | null;
  FirstName?: string | null;
  LastName?: string | null;
  phone?: string | null;
  redFlag?: boolean;
  redFlagComment?: string | null;
}

export const PatientContext = createContext<Patient>({
  patientId: 0,
  email: '',
  FirstName: '',
  LastName: '',
  phone: '',
  redFlag: false,
  redFlagComment: ''
});
